import { useEffect } from "react";

export const useDomainConfig = () => {
  useEffect(() => {
    // window.location.hostname already excludes the port
    const hostname = window.location.hostname;

    const domainConfigs = {
      localhost: {
        // for development
        title: "Domo Club",
        favicon: "/favicon-domo.ico",
      },
    };

    // Default configuration
    let config = domainConfigs["localhost"];

    // Check for domo.club domains
    if (hostname.endsWith(".domo.club") || hostname === "domo.club") {
      config = {
        title: "Domo Club",
        favicon: "/favicon-domo.ico",
      };
    }
    // Check for illio.com domains
    else if (hostname.endsWith(".illio.com") || hostname === "illio.com") {
      config = {
        title: "Illio Wealth Management",
        favicon: "/favicon-illio.ico",
      };
    }
    // Check for exact domain matches (for backward compatibility)
    else if (domainConfigs[hostname as keyof typeof domainConfigs]) {
      config = domainConfigs[hostname as keyof typeof domainConfigs];
    }

    document.title = config.title;

    // Update favicon
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = config.favicon;
  }, []);
};
